import {
  type ComponentProps,
  type ComponentType,
  createContext,
  createElement,
  type ReactElement,
  useContext,
} from "react";

/**
 * The app's router link: an anchor that navigates in place. It gets every in-app `href` the
 * design system renders, plus the anchor's other props (class, children, aria-current).
 */
export type LinkComponent = ComponentType<ComponentProps<"a">>;

export const LinkContext = createContext<LinkComponent | null>(null);

/**
 * The element a link renders through: the caller's own `render` first, then the LinkProvider's
 * component. Undefined leaves `useRender` on its default `<a>`.
 */
export function useLinkRender(render?: ReactElement): ReactElement | undefined {
  const Link = useContext(LinkContext);
  if (render) return render;
  return Link ? createElement(Link) : undefined;
}
